import {
  getCartDataDB,
  addToCartApi,
  syncLocalToDBCart,
  updateQtyAgainstProductDB,
  deleteCartItemDB,
} from "./../../api/index";
import { showMessage } from "./SweetAlert";

export function getLocalCartOnly() {
  let cart = localStorage.getItem("user_temp_cart");

  if (!cart) {
    cart = {
      cart: {
        user_id: null,
        cart_status: "active",
        // CART TOTAL GST
        gst_total: 0,
        // CART GRAND TOTAL
        grand_total: 0,
        coupon: {},
        items: [],
      },
    };

    localStorage.setItem("user_temp_cart", JSON.stringify(cart));
  } else {
    cart = JSON.parse(cart);
  }

  return cart;
}

export async function getLocalCart() {
  const BearerToken = localStorage.getItem("token");

  if (BearerToken) {
    const ApiData = await getCartDataDB();
    return ApiData.data;
  } else {
    let cart = localStorage.getItem("user_temp_cart");

    if (!cart) {
      cart = {
        cart: {
          user_id: null,
          cart_status: "active",
          // CART TOTAL GST
          gst_total: 0,
          // CART GRAND TOTAL
          grand_total: 0,
          coupon: {},
          items: [],
        },
      };

      localStorage.setItem("user_temp_cart", JSON.stringify(cart));
    } else {
      cart = JSON.parse(cart);
    }

    return cart;
  }
}

export function syncLocalCartData() {
  let CartData = getLocalCartOnly();
  let ApiResult = syncLocalToDBCart({ data: CartData });
  return ApiResult;
}

export async function addToCartLocal(product) {
  const BearerToken = localStorage.getItem("token");

  // 👉 USER LOGGED IN → DIRECT API HIT
  if (BearerToken) {
    const itemPayload = {
      product_id: product.id,
      main_category_id: product.main_category_id || null,
      sub_category_id: product.sub_category_id || null,

      price: product.price,
      discount_price: product.discount_price || null,

      quantity: 1,

      gst_rate_id: product.gst_rate_id || null,
      gst_percentage: product.gst_percentage || null,
      gst_amount: product.gst_amount || null,

      item_note: null,
    };

    let response = await addToCartApi({ data: itemPayload });

    showMessage({
      status: "success",
      message: "Product successfully added to the cart.",
    });

    return response.data.cart;
  }

  // 👉 GUEST USER → LOCAL STORAGE CART
  const cartData = await getLocalCart();

  // 🔒 SAFETY NET
  if (!cartData.cart) cartData.cart = { items: [] };
  if (!Array.isArray(cartData.cart.items)) cartData.cart.items = [];

  const items = cartData.cart.items;

  const index = items.findIndex((item) => item.product_id === product.id);

  if (index !== -1) {
    items[index].quantity += 1;
    items[index].total_price = items[index].quantity * items[index].price;
  } else {
    items.push({
      product_id: product.id,
      main_category_id: product.main_category_id || null,
      sub_category_id: product.sub_category_id || null,

      price: product.price,
      discount_price: product.discount_price || null,

      quantity: 1,
      total_price: product.price,

      gst_rate_id: product.gst_rate_id || null,
      gst_percentage: product.gst_percentage || null,
      gst_amount: product.gst_amount || null,

      item_note: null,
    });
  }

  cartData.cart.items = items;
  cartData.cart = recalculateCart(cartData.cart);

  localStorage.setItem("user_temp_cart", JSON.stringify(cartData));
  showMessage({
    status: "success",
    message: "Product successfully added to the cart.",
  });
  return cartData;
}

// No export as this function is being used in this file only
function recalculateCart(cart) {
  let subtotal = 0;
  let gstTotal = 0;

  cart.items.forEach((item) => {
    subtotal += Number(item.total_price);

    if (item.gst_percentage) {
      const gst = (item.total_price * item.gst_percentage) / 100;
      item.gst_amount = gst;
      gstTotal += gst;
    }
  });

  cart.gst_total = gstTotal;
  cart.grand_total = subtotal + gstTotal;

  return cart;
}

export function increaseQty(id, qty) {
  let newQty = qty + 1;
  updateCartQuantity(id, newQty);
  return UpdateCart();
}

export async function decreaseQty(id, qty) {
  let newQty = qty - 1;
  if (newQty == 0) {
    let Cart = await deleteCartItem(id);
    console.log("Cart", Cart);
    return !Cart ? [] : Cart.cart.items;
  } else {
    updateCartQuantity(id, newQty);
    return UpdateCart();
  }
}

export async function deleteCartItem(product_id) {
  const BearerToken = localStorage.getItem("token");

  // 🔐 Logged-in user → DB
  if (BearerToken) {
    return await deleteCartItemDB({
      product_id,
    });
  }

  // 👤 Guest user → localStorage
  let cart = localStorage.getItem("user_temp_cart");

  if (!cart) {
    return null;
  }

  cart = JSON.parse(cart);

  // ❌ Remove item
  cart.cart.items = cart.cart.items.filter(
    (item) => item.product_id !== product_id,
  );

  // ✅ Recalculate totals
  let grandTotal = 0;

  cart.cart.items.forEach((item) => {
    grandTotal += item.price * item.quantity;
  });

  cart.cart.grand_total = +grandTotal.toFixed(2);
  cart.cart.gst_total = +(grandTotal * 0).toFixed(2); // example GST

  // 🧹 Optional: clear cart if empty
  if (cart.cart.items.length === 0) {
    localStorage.removeItem("user_temp_cart");
    return null;
  }

  // 💾 Save back
  localStorage.setItem("user_temp_cart", JSON.stringify(cart));

  return cart;
}

export async function UpdateCart() {
  const CartWhole = await getLocalCart();
  return CartWhole.cart.items;
}

export function getCheckoutRedirectPath() {
  const token = localStorage.getItem("token");
  return token ? "/checkout" : "/login";
}

// FUNCTION USED IN THIS FILE ONLY
function updateCartQuantity(product_id, qty) {
  const BearerToken = localStorage.getItem("token");

  // 🔐 Logged-in user → DB
  if (BearerToken) {
    return updateQtyAgainstProductDB({
      product_id,
      qty,
    });
  }

  // 👤 Guest user → localStorage
  let cart = localStorage.getItem("user_temp_cart");

  if (!cart) {
    return null;
  }

  cart = JSON.parse(cart);

  // ✅ Update quantity
  cart.cart.items = cart.cart.items.map((item) =>
    item.product_id === product_id ? { ...item, quantity: qty } : item,
  );

  // ✅ Recalculate totals
  let grandTotal = 0;

  cart.cart.items.forEach((item) => {
    grandTotal += item.price * item.quantity;
  });

  cart.cart.grand_total = grandTotal;
  cart.cart.gst_total = +(grandTotal * 0).toFixed(2); // example GST

  // ✅ Save back to localStorage
  localStorage.setItem("user_temp_cart", JSON.stringify(cart));

  return cart;
}
